import React from "react";

function Footer() {
  return (
    <footer>
      <p>Made By Eivind Johnsen</p>
    </footer>
  );
}

export default Footer;
